// extracted by mini-css-extract-plugin
module.exports = {"button":"BackToTop_button__zgtnP","backToTop":"BackToTop_backToTop__3gb_2","backToTop__button":"BackToTop_backToTop__button__781F2"};